var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoMessages = function SvgNoMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 121,
    fill: "none",
    viewBox: "0 0 139 121"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M113.3 36.9c4.4 0 8.7-.32 12.86-.95 4.32-.64 8.79 1.45 9.88 5.68a45.5 45.5 0 0 1 1.46 11.43c0 8.45-2.33 16.45-6.5 23.61a52 52 0 0 1-2.5 3.88c-1.4 1.99-2.4 3.4-3.29 4.52-2.03 2.6-3.43 3.71-7.67 7.1l-.35.28a66 66 0 0 1-5.16 3.73 9.75 9.75 0 0 0-4.58 8.19l.14 11.88.03.77c.07 1.36.17 3.08-.97 3.1-.55 0-2.6-1.56-3.04-1.9l-10.14-9.05a9.67 9.67 0 0 0-8.04-2.22 105 105 0 0 1-15.93 1.37c-37.56 0-68-24.74-68-55.26 0-22.6 16.69-42.03 40.6-50.6C46.47.9 51.03 3.54 53.38 7.54 63.53 24.83 86.54 36.9 113.3 36.9M49.38 58.22c0-4.86-4.03-8.8-9.01-8.8a8.91 8.91 0 0 0-9.02 8.8c0 4.86 4.04 8.8 9.02 8.8a8.91 8.91 0 0 0 9.01-8.8m28.55 0c0-4.86-4.04-8.8-9.02-8.8a8.91 8.91 0 0 0-9.01 8.8c0 4.86 4.03 8.8 9.01 8.8a8.91 8.91 0 0 0 9.02-8.8m28.54 0c0-4.86-4.03-8.8-9.01-8.8a8.91 8.91 0 0 0-9.02 8.8c0 4.86 4.04 8.8 9.02 8.8a8.91 8.91 0 0 0 9.01-8.8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeOpacity: 0.8,
    strokeWidth: 1.17,
    d: "M15.72 33.86a46 46 0 0 0-3.14 6.35m27.62-28c-8.74 4.17-16.12 10.07-21.45 17.13"
  })));
};
export default SvgNoMessages;